import type { DefaultRootState } from 'react-redux';
import type { Middleware } from 'redux';

import { CALL_HISTORY_METHOD, LOCATION_CHANGE } from 'connected-react-router';
import type { FetchCacheController } from 'utils/fetchCache';

import type { Action } from 'store/createReducer';
import { extract, hasActionsCache } from 'store/injector';
import type { BatchDispatch } from 'store/middlewares/batched';
import fetchPageData from 'store/middlewares/fetchRouter/fetchPageData';
import type { FetchAction } from 'store/middlewares/fetchRouter/types';
import { getRoute, isCanceledFetchingData } from 'store/middlewares/fetchRouter/utils';

let cancelFetchingData = false;

type FetchRouterMiddleware = (cacheController: FetchCacheController) => Middleware<unknown, DefaultRootState>;

const fetchRouterMiddleware: FetchRouterMiddleware =
    (cache) =>
    ({ dispatch, getState }) =>
    (next: BatchDispatch<Action>) =>
    (action: FetchAction) => {
        if (action.type === CALL_HISTORY_METHOD) {
            if (isCanceledFetchingData(action)) {
                cancelFetchingData = true;
                return next(action);
            }
            let url = action.payload.args[0];
            if (url && url.startsWith && url.startsWith('?')) {
                url = getState().router.location.pathname + url;
            }
            void fetchPageData(cache, action, url, next, dispatch, getState);
            return undefined;
        }

        if (action.type === LOCATION_CHANGE && !hasActionsCache() && !cancelFetchingData) {
            const url = action.payload.location.pathname;
            void fetchPageData(cache, action, url, next, dispatch, getState, true);
            return undefined;
        }

        if (action.type === LOCATION_CHANGE && cancelFetchingData) {
            cancelFetchingData = false;
        }

        return next(extract(action));
    };

export default fetchRouterMiddleware;
export { getRoute };
